/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors, layers } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const fileHeaderStackingIndex = layers.navigation() - 18;
const fileHeaderStackingIndexWhenActive = fileHeaderStackingIndex + 1;

export const StickyDiffHeader = styled.div<{
  isCommentNavOpen: boolean;
  isDiffSortOpen: boolean;
  isIterativeReviewSelectorOpen: boolean;
}>`
  background-color: ${token('elevation.surface', colors.N0)};
  min-height: ${token('space.500', '40px')};
  position: sticky;
  top: var(--pr-compact-header-bottom, 0);
  z-index: ${({
    isCommentNavOpen,
    isDiffSortOpen,
    isIterativeReviewSelectorOpen,
  }) =>
    isCommentNavOpen || isDiffSortOpen || isIterativeReviewSelectorOpen
      ? `${fileHeaderStackingIndexWhenActive}`
      : `${fileHeaderStackingIndex}`};
`;
